import mixpanel from 'mixpanel-browser';

const token = process.env.REACT_APP_MIXPANEL_TOKEN;

if (!token) {
	console.error('Mixpanel token is missing in environment variables');
} else {
	try {
		mixpanel.init(token, {
			debug: process.env.REACT_APP_NODE_ENV !== 'production', // change to true for development
			track_pageview: true,
			persistence: 'cookie',
		});
	} catch (error) {
		console.error('Failed to initialize Mixpanel:', error);
	}
}

export const sendMixpanelTrackingEvent = (event: string, data: Record<string, any> = {}) => {
	// Track event in Mixpanel
	try {
		mixpanel.track(event, data);
	} catch (error) {
		console.log(`Error tracking Mixpanel event '${event}':`, error);
	}
};

export default mixpanel;
